/** * 防沉迷弹窗 */

<template>
  <div :class="[$style.wrap, $style.fullScreen]">
    <header>
      <span>提现认证</span>
      <img :src="`${$cdnLink}/wanXin/orangeTheme/fanhui.png`" alt :class="$style.fanhui" @click="close" />
    </header>
    <main>
      <div :class="$style.antiIndulged">
        <div :class="$style.content">
          <p>
            尊敬的玩家，为了保证您的账号安全，在您进行提现申请操作的时候，我们需要校验您的身份信息。
            <span>下方请输入当前本游戏中账号注册时绑定的实名信息。</span>
          </p>
          <div :class="$style.bindFm">
            <img :src="`${$cdnLink}/wanXin/orangeTheme/zhanghao.png`" alt="" />
            <input type="text" v-model.trim="form['id_card_name']" placeholder="请输入姓名" />
          </div>
          <div :class="$style.bindFm">
            <img :src="`${$cdnLink}/wanXin/orangeTheme/idcard.png`" alt="" />
            <input type="text" v-model.trim="form['id_card_num']" placeholder="请输入身份证号" />
          </div>
        </div>
        <div>
          <div :class="$style.btnGp">
            <button :class="$style.btnP" @click="submit">确定</button>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { cdnLink } from '@/config';
import _ from 'lodash';
import { mapState, mapActions } from 'vuex';
import { enterAntiPort } from '@/api/user';
import { authentication } from '@/api/activity';

export default {
  name: '',
  props: ["type"],
  data() {
    return {
      cdnLink,
      form: {
        id_card_num: '',
        id_card_name: '',
      },
    };
  },
  computed: {
    ...mapState({
      userState: (state) => state.user,
      user_id: (state) => state.user.user_id,
    }),
  },
  methods: {
    // 提交实名认证
    async submit() {
      const r = await authentication({
        user_id: this.user_id,
        id_card_name: this.form.id_card_name,
        id_card_num: this.form.id_card_num,
        type: this.type
      });
      if (r.ret == 1) {
        this.close();
        this.$emit('success');
      }
    },
    close() {
      this.form.id_card_num = '';
      this.form.id_card_name = '';
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" module>
@import '../../../../assets/css/common.scss';

.wrap {
  @include common-window();
  > header {
    position: relative;
    > span {
      font-weight: 600;
      font-style: italic;
    }
    .fanhui {
      position: absolute;
      top: 0.35rem;
      right: 0.35rem;
      width: 0.34rem;
      height: 0.25rem;
    }
  }
  > main {
    padding: 0.35rem 0.2rem;
    overflow-y: auto;
    .antiIndulged {
      .content {
        > p {
          padding: 0 0 0 0.15rem;
          font-size: 0.24rem;
          font-weight: bold;
          line-height: 20px;
          color: #444;
          > span {
            color: #fb5d56;
            font-weight: bold;
          }
        }
      }
      .bindFm {
        width: 4.44rem;
        height: 0.68rem;
        background: #f7f7f7;
        border-radius: 0.1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0.15rem auto;
        > img {
          margin-left: 0.06rem;
          width: 0.26rem;
        }
        > input {
          width: 3.8rem;
          margin: 0 0.1rem;
          background: none;
          border: none;
        }
      }
      .btnGp {
        display: flex;
        justify-content: center;
        margin-top: 0.15rem;
        > button {
          @include common-button();
          width: 2rem;
          height: 0.58rem;
          margin: 0 0.2rem;
        }
      }
      .antiInduledHint {
        color: #888888;
        font-size: 0.2rem;
        line-height: 0.26rem;
        text-align: center;
        margin-top: 0.1rem;
        > button {
          background: none;
          border: none;
          outline: none;
          color: $primary-color;
          font-size: 0.2rem;
        }
        > a {
          color: $primary-color;
        }
      }
      .antiInduledCp {
        position: absolute;
        left: 0;
        top: -1000rem;
        z-index: -1;
      }
    }
  }
  // 全屏版本
  &.fullScreen {
    @include full-screen-window();
    > header {
      position: relative;
      > span {
        font-weight: 600;
        font-style: italic;
      }
      .fanhui {
        position: absolute;
        top: 17px;
        right: 17px;
        width: 17px;
        height: 12px;
      }
    }
    > main {
      padding: 17px 5px;
      overflow-y: auto;
      .antiIndulged {
        .content {
          min-height: 100px;
        }
        p {
          padding: 0 0 0 7px;
          font-size: 12px;
        }
        .bindFm {
          width: 222px;
          height: 34px;
          background: #f7f7f7;
          border-radius: 5px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 7px auto;
          > img {
            width: 13px;
            margin-left: 3px;
          }
          > input {
            width: 190px;
            margin: 0 5px;
            background: none;
            border: none;
          }
        }
        .btnGp {
          display: flex;
          justify-content: center;
          margin-top: 7px;
          > button {
            @include full-screen-button();
            width: 100px;
            height: 29px;
            margin: 0 10px;
          }
        }
        .antiInduledHint {
          color: #888888;
          font-size: 10px;
          line-height: 13px;
          text-align: center;
          margin-top: 10px;
          > a {
            background: none;
            border: none;
            outline: none;
            color: $primary-color;
            font-size: 10px;
          }
          > span {
            color: $primary-color;
          }
        }
        .antiInduledCp {
          position: absolute;
          left: 0;
          top: -1000px;
          z-index: -1;
        }
      }
    }
  }
}
</style>
,
